import { LabMDM } from "./lab";
import { OperetionHistoryDTO } from "./operationHistory";
import { ReadModeCount } from "./readModeCountDTO";

//this model is used to define the flowcell details

export class FlowCell{
    
    _id: string;
    flowCellName:string;
    lab:LabMDM;
    sequencer:string;
    flowCellType:string;
    flowCellMode:string;
    physicalLanes:number;
    logicalLanes:number;
    totalCapacity:number;
    laneCapacity:number;
    capabilities:string[];
    active:boolean;
    history:OperetionHistoryDTO[];
    readModeCount:ReadModeCount[];
}